module.exports = __webpack_public_path__ + "media/images/logos/zelt-79a559291c6c1f69748559bc3d7322cb.png";